const TableHeaderWithSort = ({ displayName, sortFunction }) => {
	return (
		<span>
			{displayName}{' '}
			<i
				className='fa-solid fa-arrow-down-wide-short'
				onClick={sortFunction}
				style={{ cursor: 'pointer' }}
			></i>
		</span>
	);
};

export default TableHeaderWithSort;
